import axios from '../axios'
import * as utils from '@/utils'
const loading = 'loading'
const cache = {}
// const isImage = src => /\.(jpe?g|bmp|png|gif)$/.test(src)
const isImage = src => src && src.match(/\.(jpe?g|png|gif|bmp)/) ? 'true' : 'false'
const formatPhotoList = data => data.map(item => {
  const src = utils.getResourceSrc(item)
  return { ...item, src, isImage: isImage(src) }
})
/**
 * 特殊情况一览
 */
export const getSpecialList = data =>
  axios
    .post('/bzmj/special/list', data, {
      loading
    })
    .then(({ data = {} }) => {
      const { row: list = [], total = 0 } = data.data || {}
      return {
        list,
        total
      }
    })

// 获取协助人列表
export const getHelpers = data =>
  axios
    .post('/bzmj/special/helpers', data, {
      loading: 'specialhelpers',
      cancel: 'special.helpers'
    })
    .then(({ data = {} }) => data.data || [])

/**
 * 批量协助
 * @param {string} help_msg
 * @param {number} audit_id
 * @param {array} help_list
 */
export const batchAssist = data => axios.post('/bzmj/special/assist', data)

/**
 * 在线申请一览
 */
export const getAppealList = data =>
  axios
    .post('/bzmj/appeal/list', data, {
      loading
    })
    .then(({ data = {} }) => {
      const { row: list = [], total = 0 } = data.data || {}
      return {
        list,
        total
      }
    })

/**
 * 申请审计项目一览
 */
export const getAppealDetailList = data =>
  axios
    .post('/bzmj/appeal/appealist', data, {
      loading
    })
    .then(({ data = {} }) => {
      const { row: list = [], total = 0 } = data.data || {}
      return {
        list,
        total
      }
    })
/**
 * 执行资料文件列表
 */
export const getAppealAudioFilelist = data =>
  axios
    .post('/bzmj/home/Audio/AudioFilelist', data, {
      loading
    })
    .then(({ data = {} }) => {
      const { row: list = [], total = 0 } = data.data || {}
      return {
        list,
        total
      }
    })
/**
 * 申诉处理一览
 */
export const getAppealHandleList = data =>
  axios
    .post('/bzmj/appeal/dealist', data, {
      loading
    })
    .then(({ data = {} }) => {
      const { row: list = [], total = 0 } = data.data || {}
      return {
        list,
        total
      }
    })
/**
 * 在线申诉-申诉审计-详情
 */
export const getAppealDetail = data =>
  axios
    .post('/bzmj/appeal/detail', data, {
      loading,
      cancel: 'special.detail'
    })
    .then(({ data = {} }) => {
      const { audit_arr, process = [], special_arr, appeal_arr, shifen_photos, child_task_type, audioFileList, tag_arr = [] } = data.data || {}
      // const { photos: appealPhoto = [] } = appeal_arr || []
      const {
        photos = [],
        child_task_code,
        check_standard,
        dealer_shortname,
        system_code,
        iterm,
        question_type,
        checked_type = [],
        lose_photo,
        final_lose_reason: reason,
        final_check_res: result,
        ...detail
      } = audit_arr || {}
      const { special_desc: desc, special_dispose_desc: suggest, special_dispose_result: dispose_result, special_dispose_status: status, photos: uploads } =
        special_arr || {}
      return {
        audit: {
          check_standard,
          question_type,
          photo: lose_photo,
          reason,
          result,
          desc,
          ...detail
        },
        appeal: appeal_arr,
        /* appeal: {
          ...appeal_arr,
          photos: appealPhoto.map(({ file_path, ...item }) => {
            return {
              ...item,
              url: file_path
            }
          })
        }, */
        special: {
          suggest,
          status,
          desc, // 特殊情况申请说明
          result: dispose_result, // 特殊情况处理结果
          photos: uploads.map(({ file_path }) => file_path)
        },
        title: `${child_task_code}：${dealer_shortname}`,
        header: `${system_code}-${iterm}`,
        checked_type,
        photos: formatPhotoList(photos),
        process,
        tag_arr,
        audioFileList: audioFileList || [],
        shifen_photos: shifen_photos || [],
        show_shifen: child_task_type === '2'
      }
    })

/**
 * 异常运营一览
 */
export const getExcepHandleList = data =>
  axios
    .post('/bzmj/abnormal/list', data, {
      loading
    })
    .then(({ data = {} }) => {
      const { row: list = [], total = 0 } = data.data || {}
      return {
        list,
        total
      }
    })

/**
 * 异常运营下拉框
 */
export const getExcepSelect = data =>
  axios
    .post('/select/abnormalSelect', data, {
      loading
    })
    .then(({ data = {} }) => {
      const { abnormal_dispose_status: status = [], abnormal_dispose_res: result = [], abnormal: type = [] } = data.data || {}
      return {
        status,
        result,
        type
      }
    })
/**
 * 异常运营-详情
 */
const colsExcep = [
  {
    label: '年度',
    prop: 'year'
  },
  {
    label: '期次',
    prop: 'period'
  },
  {
    label: '门店',
    prop: 'dealer_shortname'
  }
]
export const getExcepDetail = data =>
  axios.post('/bzmj/abnormal/detail', data, { loading, cancel: 'special.detail' }).then(({ data = {} }) => {
    const { audit_arr, process = [] } = data.data || {}
    const {
      photos = [],
      button,
      iterm: item,
      abnormal_dispose_status: status,
      checked_type = [],
      abnormal,
      ...detail
    } = audit_arr || {}
    return {
      audit: {
        button,
        ...detail
      },
      checked_type,
      detail: colsExcep.map(({ label, prop }) => ({ label, value: detail[prop], prop })),
      photos: formatPhotoList(photos),
      process,
      status,
      abnormal
    }
  })

/**
 * 获取邮件模板
 */
export const getEmailTemplate = data => {
  if (cache.email) return cache.email
  return (cache.email = axios
    .post('/bzmj/special/emailModel', data, {
      loading: 'email'
    })
    .then(
      ({ data = {} }) => utils.echoHtml(data.data || ''),
      () => {
        cache.email = null
      }
    ))
}

/**
 * 获取申诉邮件模板
 */
export const getAppealEmailTemplate = () => {
  if (cache.appeal_email) return cache.appeal_email
  return (cache.appeal_email = axios.post('/bzmj/appeal/emailModel', null, { loading: 'email' }).then(({ data = {} }) => utils.echoHtml(data.data || ''), () => (cache.appeal_email = null)))
}
/**
 * 特殊情况发送邮件
 */
export const sendEmail = data =>
  axios.post('/bzmj/special/send', data, {
    loading: 'sendemail',
    cancel: 'special.sendemail'
  })

/**
 * 申诉处理发送邮件
 */
export const appealSendEmail = data => axios.post('/bzmj/appeal/send', data, { loading: 'sendemail', cancal: 'appeal.sendemail' })

const appealCols = [
  {
    label: '业务类型',
    prop: 'business_name'
  },
  {
    label: '年度',
    prop: 'year'
  },
  {
    label: '期次',
    prop: 'period'
  },
  {
    label: '任务名称',
    prop: 'task_name'
  },
  {
    label: '检核标准',
    prop: 'check_standard'
  },
  {
    label: '战区',
    prop: 'daqu_name'
  },
  {
    label: '小区',
    prop: 'xiaoqu_name'
  },
  {
    label: '门店',
    prop: 'dealer_shortname'
  },
  {
    label: '申诉编号',
    prop: 'appeal_code'
  }
]

const specialCols = [
  {
    label: '业务类型',
    prop: 'business_name'
  },
  {
    label: '年度',
    prop: 'year'
  },
  {
    label: '期次',
    prop: 'period'
  },
  {
    label: '任务名称',
    prop: 'task_name'
  },
  {
    label: '检核标准',
    prop: 'check_standard'
  },
  {
    label: '战区',
    prop: 'daqu_name'
  },
  {
    label: '小区',
    prop: 'xiaoqu_name'
  },
  {
    label: '门店',
    prop: 'dealer_shortname'
  },
  {
    label: '特殊情况编号',
    prop: 'special_code'
  }
]

/**
 * 特殊情况一览-详情
 */
export const getSpecialDetail = data =>
  axios
    .post('/bzmj/special/detail', data, {
      loading,
      cancel: 'special.detail'
    })
    .then(({ data = {} }) => {
      const { audit_arr = {}, uploads = [], process = [], shifen_photos, child_task_type } = data.data || {}
      const {
        photos = [],
        system_code,
        iterm: item,
        final_check_res: result,
        final_lose_reason: reason,
        lose_photo: photo,
        special_desc: desc,
        special_dispose_desc: suggest,
        special_dispose_result: dispose_result,
        special_dispose_status: status,
        rollback: canRevoke,
        button: canForward,
        save: canSave,
        ...detail
      } = audit_arr || {}

      const title = [system_code, item].filter(i => i).join('-')
      const operateAuths = []
      canForward && operateAuths.push('forward')
      canSave && operateAuths.push('save')
      canRevoke && operateAuths.push('revoke')
      return {
        title,
        system_code,
        data: detail,
        audit: {
          result,
          reason,
          photo
        },
        canRevoke,
        special: {
          desc, // 特殊情况申请说明
          suggest, // 特殊情况处理意见
          result: dispose_result, // 特殊情况处理结果
          photos: formatPhotoList(uploads)
        },
        detail: specialCols.map(({ label, prop }) => ({
          label,
          value: detail[prop],
          prop
        })),
        photos: photos.map((item, index) => {
          const src = utils.getResourceSrc(item)
          return {
            id: index,
            ...item,
            isImage: isImage(src),
            src
          }
        }),
        process: process.map(item => item.string),
        status: Number(status) || 0,
        operateAuths,
        shifen_photos: shifen_photos || [],
        show_shifen: child_task_type === '2'
      }
    })

/**
 * 撤回操作
 */
export const revoke = (audit_id, reason) =>
  axios.post(
    '/bzmj/special/rollback',
    {
      audit_id,
      reason
    },
    {
      loading: 'revoke',
      cancel: 'special.revoke'
    }
  )
export const cancelAppeaByDealer = (id, audit_id) =>
  axios.post('/bzmj/appeal/retract', { id, audit_id }, { loading: 'cancel' })
/**
 * 获取历史调用
 */
export const history = data => {
  if (data.year && data.period) {
    return axios.post('/bzmj/special/history', data, { loading }).then(({ data = {} }) => {
      const { audit_arr = {}, uploads = [], process = [], shifen_photos, child_task_type } = data.data || {}
      const {
        photos = [],
        system_code,
        iterm: item,
        final_check_res: result,
        final_lose_reason: reason,
        lose_photo: photo,
        special_desc: desc,
        special_dispose_desc: suggest,
        special_dispose_result: dispose_result,
        special_dispose_status: status,
        ...detail
      } = audit_arr || {}
      const title = [system_code, item].filter(i => i).join('-')
      return {
        title,
        system_code,
        data: detail,
        audit: {
          result,
          reason,
          photo
        },
        special: {
          desc, // 特殊情况申请说明
          suggest, // 特殊情况处理意见
          result: dispose_result, // 特殊情况处理结果
          photos: formatPhotoList(uploads)
        },
        detail: appealCols.map(({ label, prop }) => ({
          label,
          value: detail[prop],
          prop
        })),
        photos: photos.map((item, index) => {
          const src = utils.getResourceSrc(item)
          return {
            id: index,
            ...item,
            isImage: isImage(src),
            src
          }
        }),
        process: process.map(item => item.string),
        status: Number(status) || 0,
        shifen_photos: shifen_photos || [],
        show_shifen: child_task_type === '2'
      }
    })
  }
  return Promise.reject(new Error('参数不对'))
}

/**
 * 保存、提交特殊情况
 * @param {string} submit_type 提交类型 save=保存 submit=提交
 * @param {string} audit_id 审计id
 * @param {string} special_dispose_result 特殊情况处理结果
 * @param {stirng} special_dispose_desc 处理意见
 */
export const submit = (submit_type, audit_id, special_dispose_result, special_dispose_desc) =>
  axios.post('/bzmj/special/submit', { submit_type, audit_id, special_dispose_result, special_dispose_desc }, { loading: 'submit' })

/**
 * 切换项目详情
 */
export const switchAudit = (type, audit_id) =>
  axios.post('/bzmj/special/next', { audit_id, type }, { loading: 'switch', cancel: 'special.switch' }).then(({ data = {} }) => data.data || {})

/**
 * 申诉处理-详情
 */
export const appealProcessDetail = (audit_id, dealer_code) =>
  axios.post('/bzmj/appeal/dealdeatil', { audit_id, dealer_code }, { loading, cancel: 'special.processdetail' }).then(({ data = {} }) => {
    const { audit_arr, process_arr: _process = [], process_special = [], appeal_arr, special_arr, speciallose_arr, shifen_photos, child_task_type, audioFileList = [] } = data.data || {}
    const {
      photos = [],
      tageloses = [],
      system_code,
      question_type,
      iterm: item,
      final_check_res: result,
      final_lose_reason: reason,
      lose_photo: photo,
      button: canForward,
      save: canSave,
      rollback: canRevoke,
      ...detail
    } = audit_arr || {}
    // const { appeal_dispose_status: status, appeal_desc: desc, photos: appealPhotos = [], appeal_dispose_desc: suggest, appeal_result } = appeal_arr || {}
    const { special_desc, special_dispose_desc, special_dispose_result, photos: specialPhotos = [] } = special_arr || {}
    const title = [system_code, item].filter(i => i).join('-')
    const photoOptions = photos.reduce((acc, { id }) => {
      const mappedOptions = speciallose_arr.map(loseItem => ({
        ...loseItem,
        id: `${loseItem.id}-${id}`
      }))
      return acc.concat(mappedOptions)
    }, [])
    const operateAuths = []
    canForward && operateAuths.push('forward')
    canSave && operateAuths.push('save')
    canRevoke && operateAuths.push('revoke')
    return {
      title,
      question_type,
      system_code,
      data: detail,
      audit: {
        result,
        reason,
        photo
      },
      appeal: appeal_arr,
      /* appeal: {
        desc, // 申诉申请说明
        suggest, // 申诉处理意见
        result: appeal_result, // 申诉处理结果
        photos: formatPhotoList(appealPhotos)
      }, */
      special: {
        desc: special_desc,
        suggest: special_dispose_desc,
        result: special_dispose_result,
        photos: formatPhotoList(specialPhotos),
        process: process_special.map(item => item.string)
      },
      detail: appealCols.map(({ label, prop }) => ({
        label,
        value: detail[prop],
        prop
      })),
      photos: photos.map((item, index) => {
        const src = utils.getResourceSrc(item)
        return {
          id: index,
          ...item,
          isImage: isImage(src),
          src
        }
      }),
      tageloses: tageloses,
      process: _process.map(item => item.string),
      status: Number(status) || 0,
      operateAuths,
      photoOptions,
      audioFileList,
      shifen_photos: shifen_photos || [],
      show_shifen: child_task_type === '2'
    }
  })

/**
 * 申诉处理-历史调用
 */
export const appealHistory = data =>
  axios.post('/bzmj/appeal/history', data, { loading }).then(({ data = {} }) => {
    const { audit_arr, process: _process = [], process_special = [], appeal_arr, special_arr, shifen_photos, child_task_type } = data.data || {}
    const {
      photos = [],
      system_code,
      iterm: item,
      final_check_res: result,
      final_lose_reason: reason,
      lose_photo: photo,
      button: canForward,
      save: canSave,
      rollback: canRevoke,
      ...detail
    } = audit_arr || {}
    const { appeal_dispose_status: status, appeal_desc: desc, photos: appealPhotos = [], appeal_dispose_desc: suggest, appeal_result } = appeal_arr || {}
    const { special_desc, special_dispose_desc, special_dispose_result, photos: specialPhotos = [] } = special_arr || {}
    const title = [system_code, item].filter(i => i).join('-')
    return {
      title,
      system_code,
      data: detail,
      audit: {
        result,
        reason,
        photo
      },
      appeal: {
        desc, // 申诉申请说明
        suggest, // 申诉处理意见
        result: appeal_result, // 申诉处理结果
        photos: formatPhotoList(appealPhotos)
      },
      special: {
        desc: special_desc,
        suggest: special_dispose_desc,
        result: special_dispose_result,
        photos: formatPhotoList(specialPhotos),
        process: process_special.map(item => item.string)
      },
      detail: appealCols.map(({ label, prop }) => ({
        label,
        value: detail[prop],
        prop
      })),
      photos: photos.map((item, index) => {
        const src = utils.getResourceSrc(item)
        return {
          id: index,
          ...item,
          isImage: isImage(src),
          src
        }
      }),
      process: _process.map(item => item.string),
      status: Number(status) || 0,
      shifen_photos: shifen_photos || [],
      show_shifen: child_task_type === '2'
    }
  })

/**
 * 申诉处理-撤销
 */
export const appealRevoke = (audit_id, appeal_id, reason) => axios.post('/bzmj/appeal/rollback', { audit_id, appeal_id, reason }, { loading: 'revoke', cancel: 'special.appealrevoke' })

/**
 * 保存、提交申诉处理
 * @param {string} submit_type 提交类型 save=保存 submit=提交
 * @param {string} audit_id 审计id
 * @param {string} appeal_result 申述处理结果
 * @param {stirng} appeal_dispose_desc 申诉处理意见
 */
export const appealSubmit = (submit_type, audit_id, appeal_result, appeal_dispose_desc) =>
  axios.post('/bzmj/appeal/operate', { submit_type, audit_id, appeal_result, appeal_dispose_desc }, { loading: 'submit' })

/**
 * 申诉处理转发协助
 * @param {string} help_msg 留言
 * @param {number} audit_id 已下发子任务门店审计项目主键 id，从列表中获取(支持多个数组形式)
 * @param {number} help 协助人id
 */
export const appealAssist = (help_msg, audit_id, help) => axios.post('/bzmj/appeal/assist', { help_msg, audit_id, help })

/**
 * 申诉处理-切换项目
 */
export const appealSwitch = (type, audit_id) =>
  axios.post('/bzmj/appeal/next', { type, audit_id }, { loading: 'switch', cancel: 'special.appealswitch' }).then(({ data = {} }) => data.data || {})

/**
 * 被重置的异常运营任务个数
 */
export const resetAbnormalCount = () =>
  axios.post('/bzmj/abnormal/nums', {}, { loading: 'resetAbnormal' }).then(({ data = {} }) => {
    const { total = 0 } = data.data || {}
    return total
  })

/**
 * 异常运营提报情况
 */
export const abnormalSubmitStatus = data =>
  axios.post('/bzmj/abnormal/normalList', data, { loading, cancel: 'special.abnormallist' }).then(({ data = {} }) => {
    const { row: list, total = 0 } = data.data || {}
    return { list, total }
  })

/**
 * 确认提交异常情况
 */
export const confirmSubmitAbnormal = data => axios.post('/bzmj/abnormal/confirm', data, { loading: 'submit' })

/**
 * 被重置异常运营详情
 */
export const resetAbnormalDetail = (audit_id, dealer_code) =>
  axios.post('/bzmj/abnormal/resetDeatil', { audit_id, dealer_code }, { loading }).then(({ data = {} }) => {
    const { audit_arr } = data.data || {}
    const { system_code = '', abnormal_types = [], photos = [], check_abnormal_types: types = [], button } = audit_arr
    const abnormals_photos = []
    const checkbox = photos.map((item, index) => {
      const isChecked = item.abnormal_status === '1'
      if (isChecked) abnormals_photos.push(item.id)
      return { text: `照片${index + 1}`, label: item.id }
    })
    return {
      system_code,
      abnormals_photos,
      checkbox,
      canEdit: button,
      images: photos.map(({ photo: title, check_content: desc, ...item }) => {
        const src = utils.getResourceSrc(item)
        return {
          src,
          isImage: isImage(src),
          title,
          desc,
          ...item
        }
      }),
      abnormalTypes: abnormal_types.map(({ id: label, abnormal: name }) => ({ name, label, checked: types.some(item => item.id === label) }))
    }
  })

/**
 * 保存
 */
export const saveResetAbnormal = (audit_id, abnormal, ids) => axios.post('/bzmj/abnormal/save', { audit_id, abnormal, ids }, { loading: 'submit' })

/**
 * 切换任务
 */
export const switchResetCase = (type, audit_id) =>
  axios.post('/bzmj/abnormal/renext', { type, audit_id }, { loading: 'switch' }).then(({ data = {} }) => data.data || {})

/**
 * 异常运营情况详情 - 保存及提交
 */
/**
 * 创建申诉批次
 */
export const createAppealBatch = data => axios.post('/Appeal/batch/create', data, { loading: 'createBatch' })

/**
 * 上传申诉凭证
 */
export const uploadAppealEvidence = file => {
  const formData = new FormData()
  formData.append('file', file)
  return axios.post('/Appeal/upload/image', formData, {
    loading: 'upload',
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(({ data = {} }) => data.data || {})
}

/**
 * 获取批次准备信息
 */
export const getAppealBatchPrepare = answerKeys => axios.post('/Appeal/batch/prepare', answerKeys, { loading: 'prepare' })


